import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { stateMileageTaxRateState } from './stateMileageTaxRateState';
import { StateMileageTaxRatesState } from '../types';
import { Year, Quarter } from 'app/services/api/models/IFTATaxRate';

export const stateMileageTaxRateSlice = createSlice({
  name: 'stateMileageTaxRates',
  initialState: stateMileageTaxRateState,
  reducers: {
    setIFTATaxRates: (
      state,
      action: PayloadAction<StateMileageTaxRatesState['iftaTaxRates']>,
    ) => {
      state.iftaTaxRates = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setTotalRecordCounts: (state, action: PayloadAction<number>) => {
      state.totalRecordCount = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setSortField: (state, action: PayloadAction<string>) => {
      state.sortField = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<number>) => {
      state.totalCount = action.payload;
    },
    setYear: (state, action: PayloadAction<Year | undefined>) => {
      state.year = action.payload;
    },
    setQuarter: (state, action: PayloadAction<Quarter | undefined>) => {
      state.quarter = action.payload;
    },
    setState: (state, action: PayloadAction<string>) => {
      state.state = action.payload;
    },
    setCsvUploadModal: (state, action: PayloadAction<boolean>) => {
      state.csvUploadModal = action.payload;
    },
    setResetData: () => stateMileageTaxRateState,
  },
});

export const { actions: stateMileageTaxRateActions } = stateMileageTaxRateSlice;

export const selectStateMileageTaxRate = (state: RootState) =>
  state.stateMileageTaxRates;

export const selectIFTATaxRates = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.iftaTaxRates,
);

export const selectLimit = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.limit,
);

export const selectPageIndex = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.pageIndex,
);

export const selectTotalRecordCount = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.totalRecordCount,
);

export const selectSortBy = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.sortBy,
);

export const selectSortField = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.sortField,
);

export const selectTotalCount = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.totalCount,
);

export const selectYear = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.year,
);

export const selectQuarter = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.quarter,
);

export const selectState = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.state,
);

export const selectCsvUploadModal = createSelector(
  selectStateMileageTaxRate,
  (state: StateMileageTaxRatesState) => state.csvUploadModal,
);

export default stateMileageTaxRateSlice.reducer;
